import { useTranslation } from 'react-i18next';
import { DiscountType, PromoTypeEnum } from '../api/types';

const usePromoCodeOptions = (companyCurrency?: string) => {
    const { t } = useTranslation('promoCodeDetails');

    const promoCodeTypeOptions = [
        {
            value: PromoTypeEnum.Discount,
            label: t('promoCodeDetails:options.promoType.discount'),
        },
        {
            value: PromoTypeEnum.Gift,
            label: t('promoCodeDetails:options.promoType.gift'),
        },
    ];

    const discountTypeOptions = [
        {
            value: DiscountType.Percentage,
            label: t('promoCodeDetails:options.discountType.percentage'),
        },
        {
            value: DiscountType.Value,
            label: companyCurrency,
        },
    ];

    return {
        promoCodeTypeOptions,
        discountTypeOptions,
    };
};

export default usePromoCodeOptions;
